import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const externalDeliveryFileUploadDeleteService = (data: any) => {
  return axiosInstance
    .post(ENDPOINTS.ADMIN.EXTERNAL_DELIVERY.UPLOAD.DELETE, data)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
